import { USER_INFO_KEY, USER_ID_KEY } from "./const";
import { getIMUserInfo } from "./service";

/**
 * 获取令牌
 */
export const getUidAndToken = async (forceUpdate?: boolean) => {
  const userId = localStorage.getItem(USER_ID_KEY) || '';
  const storeUserInfo = localStorage.getItem(USER_INFO_KEY);
  console.log('storeUserInfo', storeUserInfo, userId);
  if (forceUpdate || !storeUserInfo || JSON.parse(storeUserInfo).userId !== userId) {
    try {
      const { data } = await getIMUserInfo(userId);
      const userInfo = {
        userId: data.userId,
        userToken: data.token,
      };
      localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
      return userInfo;
    } catch (error) {
      console.error("getUidAndToken error", error);
      return null;
    }
  } else if (storeUserInfo) {
    return JSON.parse(storeUserInfo);
  }
};
